import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title:
    "Controla receives funding from MSB to strengthen Sweden’s digital resilience",
  header:
    "Controla receives funding from MSB to strengthen Sweden’s digital resilience",
  date: "2025-10-16",
  description:
    "Controla receives funding from MSB and NCC‑SE to help organizations understand their critical systems, dependencies, and cyber risks across the digital supply chain.",
  category: "company",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
